/** The app mark — a strawberry, the same artwork as `public/icon.svg`, inlined
 *  so it inherits size and needs no network request.
 *
 *  Fewer seeds than the icon file: this renders at ~34px, where the icon's full
 *  scatter turns to mush. Everything else — proportions, palette, the five-leaf
 *  calyx — matches, so the mark and the home-screen icon read as one thing. */
export function Mark({ size = 34 }: { size?: number }) {
  return (
    <svg
      className="topbar__mark"
      width={size}
      height={size}
      viewBox="0 0 1000 1000"
      role="img"
      aria-label="ALa"
    >
      <rect width="1000" height="1000" rx="185" fill="#FBF8F3" />
      <g fill="#2F7A4F">
        <path
          d="M500,352 C474,304 468,256 500,204 C532,256 526,304 500,352 Z"
          transform="rotate(-62 500 352)"
        />
        <path d="M500,352 C474,304 468,256 500,204 C532,256 526,304 500,352 Z" />
        <path
          d="M500,352 C474,304 468,256 500,204 C532,256 526,304 500,352 Z"
          transform="rotate(62 500 352)"
        />
      </g>
      <path
        d="M500,352 C430,318 352,330 316,392 C268,462 262,548 300,640 C344,742 430,830 500,845 C570,830 656,742 700,640 C738,548 732,462 684,392 C648,330 570,318 500,352 Z"
        fill="#E0312E"
      />
      <g fill="#FBF8F3">
        <ellipse cx="420" cy="480" rx="19" ry="27" transform="rotate(-18 420 480)" />
        <ellipse cx="580" cy="480" rx="19" ry="27" transform="rotate(18 580 480)" />
        <ellipse cx="500" cy="600" rx="19" ry="27" />
        <ellipse cx="386" cy="620" rx="17" ry="24" transform="rotate(-14 386 620)" />
        <ellipse cx="614" cy="620" rx="17" ry="24" transform="rotate(14 614 620)" />
      </g>
    </svg>
  )
}
